<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  summary: {
    type: Object,
    default: () => ({}),
  },
  activeStatus: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['selectStatus']);

const { t } = useI18n();

const STATUS_META = [
  { key: 'pending', color: 'text-n-slate-12' },
  { key: 'sent', color: 'text-n-blue-11' },
  { key: 'delivered', color: 'text-n-teal-11' },
  { key: 'read', color: 'text-n-teal-11', hasPrivacyAlert: true },
  { key: 'replied', color: 'text-n-teal-11' },
  { key: 'failed', color: 'text-n-ruby-11' },
];

const tiles = computed(() =>
  STATUS_META.map(meta => ({
    ...meta,
    label: t(`CAMPAIGN.ANALYTICS.STATUS.${meta.key.toUpperCase()}`),
    value: props.summary?.[meta.key] || 0,
    isActive: props.activeStatus === meta.key,
  }))
);
</script>

<template>
  <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
    <button
      v-for="tile in tiles"
      :key="tile.key"
      type="button"
      class="flex flex-col items-start gap-1 p-4 text-left transition-colors rounded-xl outline outline-1 outline-n-container bg-n-solid-2 hover:bg-n-solid-3"
      :class="{ 'ring-2 ring-n-brand': tile.isActive }"
      @click="emit('selectStatus', tile.key)"
    >
      <span class="flex items-center gap-1 text-sm font-medium text-n-slate-11">
        {{ tile.label }}
        <fluent-icon
          v-if="tile.hasPrivacyAlert"
          v-tooltip="t('CAMPAIGN.ANALYTICS.READ_PRIVACY_ALERT')"
          icon="info"
          size="14"
          class="text-n-slate-10"
        />
      </span>
      <span class="text-2xl font-medium" :class="tile.color">
        {{ tile.value }}
      </span>
    </button>
  </div>
</template>
